module.exports = __webpack_public_path__ + "img/40_38_078_300.70c949d3.jpg";